// React Dependencies
import React, { useState } from 'react';
// Common Dependencies
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// Components
import { Container, InputGroup, NavDropdown, Navbar } from 'react-bootstrap';
// Alert
import { toast } from 'react-toastify';
// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
// Auth Components
import { logoutSuccess, loggedUser } from '../../../store/features/authSlice';
import { LogoUrlFront } from '..';
// API Call
import { useLogout, useRouteAccessList } from '@hooks';
import { isMobileOrTablet } from '../../../../helpers/commonHelpers';
// Form search field
import Form from 'react-bootstrap/Form';
// Search bar Icon
import { IoSearchOutline } from 'react-icons/io5';
//responsive toggle sidebar icon
import { TbLayoutSidebarRightCollapse } from "react-icons/tb";

const Header = (props) => {
  // Navigate And Dispatch
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [toggleResClass, setToggleResClass] = useState(false);

  // Route
  const [routeName, setRouteNames] = useState([]);
  useRouteAccessList((response) => {
    setRouteNames(response.data.route_name);
  });
  const shouldShowRoute = (route) => {
    if (routeName) {
      return routeName.includes(route);
    }
  };
  // Action Handlers
  const handleEditProfile = (event) => {
    // navigate('/edit-profile');

    const url = `/my-profile`;
    if (event.ctrlKey || event.metaKey) {
      // Ctrl + Click (Windows/Linux) or Cmd + Click (Mac) => Open in new tab
      window.open(url, '_blank');
    } else {
      // Normal click => Navigate in same tab
      navigate(url);
    }
  };
  const handleLogout = () => {
    doUserLogout();
  };
  // Auth Check
  const checkLoggedInUser = useSelector(loggedUser);
  // Props
  const { t } = props;
  const UserMenu = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 19.1C15.0258 19.1 19.1 15.0258 19.1 10C19.1 4.97421 15.0258 0.9 10 0.9C4.97421 0.9 0.9 4.97421 0.9 10C0.9 15.0258 4.97421 19.1 10 19.1Z"
        stroke="#5C5C5C"
        strokeWidth="0.2"
      />
      <path
        d="M10 10.7929L7.73162 8.14645C7.56425 7.95118 7.29289 7.95118 7.12553 8.14645C6.95816 8.34171 6.95816 8.65829 7.12553 8.85355L9.69695 11.8536C9.86432 12.0488 10.1357 12.0488 10.303 11.8536L12.8745 8.85355C13.0418 8.65829 13.0418 8.34171 12.8745 8.14645C12.7071 7.95118 12.4358 7.95118 12.2684 8.14645L10 10.7929Z"
        fill="#565656"
      />
      <mask
        id="mask0_2053_45561"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="7"
        y="8"
        width="6"
        height="4">
        <path
          d="M10 10.7929L7.73162 8.14645C7.56425 7.95118 7.29289 7.95118 7.12553 8.14645C6.95816 8.34171 6.95816 8.65829 7.12553 8.85355L9.69695 11.8536C9.86432 12.0488 10.1357 12.0488 10.303 11.8536L12.8745 8.85355C13.0418 8.65829 13.0418 8.34171 12.8745 8.14645C12.7071 7.95118 12.4358 7.95118 12.2684 8.14645L10 10.7929Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2053_45561)"></g>
    </svg>
  );
  const { mutate: doUserLogout } = useLogout(
    (response) => {
      dispatch(logoutSuccess());
      window.addEventListener('storage', (e) => {
        e.isLogout = 1;
      });
      navigate('/login');
      const body = document.body;
      body.className = '';
      body.classList.add('bg-box');
      toast.success(response.message);
    },
    (error) => {
      window.scrollTo(0, 0);
      toast.success(error.message);
    }
  );
  return (
    <>
      <Navbar className="sticky-top navbar-section">
        <Container fluid className="container-section">
          <Navbar.Brand className="dashboard-logo">
            {/* <img src={'/admin' + LogoImage} alt="logo" width={'100%'} className="nav-brand" /> */}
            <LogoUrlFront />
          </Navbar.Brand>
          <div className="header-setting-menu">
            {/* <div className="dashboard-toggle-btn-left">
              <FontAwesomeIcon
                icon={faBars}
                onClick={() => {
                  props.toggleClass();
                }}
              />
            </div> */}

            <div className="responsive-toggle">
              <TbLayoutSidebarRightCollapse
                // icon={faBars}
                onClick={() => {
                  if (!document.body.classList.contains('responsive-sidebar-open')) {
                    document.body.classList.add('responsive-sidebar-open', 'no-scroll');
                  } else {
                    document.body.classList.remove('responsive-sidebar-open', 'no-scroll');
                  }
                }}
              />
            </div>
            <InputGroup className="header-search-bar">
              <InputGroup.Text id="basic-addon1">
                <IoSearchOutline />
              </InputGroup.Text>
              <Form.Control
                placeholder="Search"
                aria-label="Search"
                aria-describedby="basic-addon1"
              />
            </InputGroup>
            <div className="profile-img">
              <img
                className="popup_img"
                src={checkLoggedInUser.user.profile_image}
                width="40px"
                height="40px"
                alt="profile_img"
              />
            </div>
            <NavDropdown title={UserMenu} className="profile-dropdown">
              <div className='profile-dropdown-username'>
                <img
                  src={checkLoggedInUser.user.profile_image}
                  width="40px"
                  height="40px"
                  alt="profile_img"
                />
                <div className="mobile-login-name">
                  <span>
                    {checkLoggedInUser.user.first_name + ' ' + checkLoggedInUser.user.last_name}
                  </span>
                </div>
              </div>
              <NavDropdown.Item
                className="setting-items"
                onClick={(event) => handleEditProfile(event)}>
                {t('page.header_myProfile')}
              </NavDropdown.Item>
              <NavDropdown.Item className="setting-items" onClick={handleLogout}>
                {t('page.header_logout')}
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        </Container>
      </Navbar>
    </>
  );
};
Header.propTypes = {
  toggleClass: PropTypes.any.isRequired,
  t: PropTypes.func
};
export { Header };
